import { ErrandInterface } from './errand.model';
import { CameraModel } from 'src/app/engine/models/camera.model';
import { ErrandType } from './errand-type.enum';

export class FlyToCameraErrandModel implements ErrandInterface {
  type = ErrandType.flyToCamera;
  value: CameraModel;
  params?: {
    duration: number;
  };

  constructor(cameraPosition: CameraModel) {
    this.value = cameraPosition;
  }
}
